import * as types from './types';

import { DimensionsResponse } from '../../types/redux/stores/dimensions.types';

export const getDimensionsRequest = () => ({ type: types.GET_DIMENSIONS_REQUEST });
export const getDimensionsRequestFailure = (error: any) => ({ type: types.GET_DIMENSIONS_REQUEST_FAILURE, error });
export const getDimensionsRequestSuccess = (payload: DimensionsResponse) => ({ type: types.GET_DIMENSIONS_REQUEST_SUCCESS, payload });
